import React from "react";
import { useState, useEffect } from "react";

import "../styles/cuentaAtras.css";
import { estilos } from "../Lib/estilosCuentaRegresiva";

export default function Countdown(props) {
    const { startingMinutes = 30, startingSeconds = 0 } = props;
    const [mins, setMinutes] = useState(startingMinutes);
    const [secs, setSeconds] = useState(startingSeconds);
    const [tiempoFinalizado, setTiempoFinalizado] = useState("");
    const [estilosBorde, setEstilosBorde] = useState("0.5vw solid rgb(0, 50, 126)");

    useEffect(() => {
        let sampleInterval = setInterval(() => {
        if (secs > 0) {
            setSeconds(secs - 1);
        }
        if (secs === 0) {
            if (mins === 0) {
            clearInterval(sampleInterval);
            props.valorTemporizador(true);

            } else {
            setMinutes(mins - 1);
            setSeconds(59);
            const randomValue = Math.floor((Math.random() * 30) + 1);
            setEstilosBorde(estilos[randomValue]);
            }
        }
        }, 1000);
        return () => {
        clearInterval(sampleInterval);
        setTiempoFinalizado("Tiempo Finalizado");
        };
    });

    return (
        <div className="cuentaAtras__div" style={{border: estilosBorde}}>
        {(mins === 0 && secs === 0) ? (tiempoFinalizado) : (
            <p className="cuentaAtras__p">
            {" "}
            {mins}:{secs < 10 ? `0${secs}` : secs}
            </p>
        )}
        </div>
    );
}